import { useStorage } from "vue3-storage";
import services from '../services';
export default {

    auth(to, from, next) {
       // next();
        
        const storage = useStorage();
        var token = storage.getStorageSync("token");
        services.login.verificaToken(token).then(data => {
            if (data.data.token) {
                next();

            } else {
                next('/');

            }
            //  autorizado = dat
        }).catch(function () {
            next('/');
        });
        //ajax para o backend para checar a validade do token */
    },
}